const productMapper = require('../../shelfproduct/dtmmapper/product-analytics-mapper');
const loyaltyPointsCalculator = require('../../../common/loyalty/loyalty-points-calculator');
const _ = require('lodash');

module.exports = function (data) {
    return {
        cart: {
            price: {
                basePrice: data.Trolley.Totals ? data.Trolley.Totals.Total : '',
                totalSavings: data.Trolley.Totals.TotalSavings,
                wowRewardsToSpend: data.Trolley.WowRewardsSummary ? data.Trolley.WowRewardsSummary.WowRewardsToSpend : '',
                wowRewardsEarned: data.Trolley.WowRewardsSummary ? loyaltyPointsCalculator(data.Trolley.WowRewardsSummary.WowRewardsEarned, data.rewardsPointsConversionBase, false) : '',
                currency: 'AUD',
                taxRate: data.Trolley.TaxRate,
            },
            item: _.map(_.compact(_.concat(data.Trolley.AvailableItems, data.Trolley.UnavailableItems, data.Trolley.RestrictedItems)), currentProduct => productMapper({
                product: currentProduct,
                Quantity: currentProduct.Quantity,
                Price: currentProduct.SalePrice,
            })),
            cartChange: _.map(data.cartChange, currentProduct => productMapper({
                product: currentProduct,
                Quantity: currentProduct.Quantity,
                Price: currentProduct.SalePrice,
            })),
            attributes: {},
        },
    };
};



// WEBPACK FOOTER //
// ./src/shop/trolley/dtmmapper/trolley-analytics-mapper.js